/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AwardSubscribeRequestDto } from '../models';
// @ts-ignore
import type { BalanceByUserIdRequestDto } from '../models';
/**
 * AWARDADMINORDERApi - axios parameter creator
 * @export
 */
export const AWARDADMINORDERApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Выдача баланса пользователю админом
         * @param {BalanceByUserIdRequestDto} balanceByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardAdminOrderControllerBalanceByUserId: async (balanceByUserIdRequestDto: BalanceByUserIdRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'balanceByUserIdRequestDto' is not null or undefined
            assertParamExists('awardAdminOrderControllerBalanceByUserId', 'balanceByUserIdRequestDto', balanceByUserIdRequestDto)
            const localVarPath = `/awardAdminOrder/balanceByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(balanceByUserIdRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Выдача подписки пользователю админом
         * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardAdminOrderControllerSubscribeByUserId: async (awardSubscribeRequestDto: AwardSubscribeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'awardSubscribeRequestDto' is not null or undefined
            assertParamExists('awardAdminOrderControllerSubscribeByUserId', 'awardSubscribeRequestDto', awardSubscribeRequestDto)
            const localVarPath = `/awardAdminOrder/subscribeByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(awardSubscribeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AWARDADMINORDERApi - functional programming interface
 * @export
 */
export const AWARDADMINORDERApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AWARDADMINORDERApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Выдача баланса пользователю админом
         * @param {BalanceByUserIdRequestDto} balanceByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async awardAdminOrderControllerBalanceByUserId(balanceByUserIdRequestDto: BalanceByUserIdRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.awardAdminOrderControllerBalanceByUserId(balanceByUserIdRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AWARDADMINORDERApi.awardAdminOrderControllerBalanceByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Выдача подписки пользователю админом
         * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async awardAdminOrderControllerSubscribeByUserId(awardSubscribeRequestDto: AwardSubscribeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.awardAdminOrderControllerSubscribeByUserId(awardSubscribeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AWARDADMINORDERApi.awardAdminOrderControllerSubscribeByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AWARDADMINORDERApi - factory interface
 * @export
 */
export const AWARDADMINORDERApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AWARDADMINORDERApiFp(configuration)
    return {
        /**
         * 
         * @summary Выдача баланса пользователю админом
         * @param {BalanceByUserIdRequestDto} balanceByUserIdRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardAdminOrderControllerBalanceByUserId(balanceByUserIdRequestDto: BalanceByUserIdRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.awardAdminOrderControllerBalanceByUserId(balanceByUserIdRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Выдача подписки пользователю админом
         * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        awardAdminOrderControllerSubscribeByUserId(awardSubscribeRequestDto: AwardSubscribeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.awardAdminOrderControllerSubscribeByUserId(awardSubscribeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AWARDADMINORDERApi - object-oriented interface
 * @export
 * @class AWARDADMINORDERApi
 * @extends {BaseAPI}
 */
export class AWARDADMINORDERApi extends BaseAPI {
    /**
     * 
     * @summary Выдача баланса пользователю админом
     * @param {BalanceByUserIdRequestDto} balanceByUserIdRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AWARDADMINORDERApi
     */
    public awardAdminOrderControllerBalanceByUserId(balanceByUserIdRequestDto: BalanceByUserIdRequestDto, options?: RawAxiosRequestConfig) {
        return AWARDADMINORDERApiFp(this.configuration).awardAdminOrderControllerBalanceByUserId(balanceByUserIdRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Выдача подписки пользователю админом
     * @param {AwardSubscribeRequestDto} awardSubscribeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AWARDADMINORDERApi
     */
    public awardAdminOrderControllerSubscribeByUserId(awardSubscribeRequestDto: AwardSubscribeRequestDto, options?: RawAxiosRequestConfig) {
        return AWARDADMINORDERApiFp(this.configuration).awardAdminOrderControllerSubscribeByUserId(awardSubscribeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

